import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
} from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { hot } from 'react-hot-loader/root';
import { useStyles } from './styles';

type Props = {
  open: boolean;
  message: string;
  title: string;
  onCancel: () => void;
};

const CancelButtonDialog: React.FC<Props> = ({
  open,
  message,
  title,
  onCancel,
}) => {
  const classes = useStyles();

  return (
    <>
      <Modal
        open={open}
        size="small"
        onClose={onCancel}
        data-testid="confirmation-modal"
      >
        <Box className={classes.modalTitle}>
          <ModalTitle onClose={onCancel} data-testid="confirmation-header">
            {title}
          </ModalTitle>
        </Box>
        <ModalContent>
          <Typography
            variant="body1"
            className={classes.modalText}
            data-testid="confirmation-body"
          >
            {message}
          </Typography>
        </ModalContent>
        <ModalActions>
          <Button
            onClick={onCancel}
            color="primary"
            variant="text"
            data-testid="cancel-confirmation-modal"
          >
            Cancel
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};
export default hot(CancelButtonDialog);
